import React, { useState } from "react";
import { Search, BookOpen, Code, Brain, Users, Cloud, Settings, ChevronDown, ChevronRight, ExternalLink, Database } from "lucide-react";


const iconMap = {
    Search, BookOpen, Code, Brain, Users, Cloud, Settings, ChevronDown, ChevronRight, ExternalLink, Database
};

const categories = [
  { 
      title: "Data Science, ML & Analytics", 
      icon: "Brain",
      links: [
          { "text": "Data Science Course", "url": "https://logicmojo.com/datascience-course" },
          { "text": "Data Science Introduction", "url": "https://logicmojo.com/data-science-introduction" },
          { "text": "Best Data Science Courses", "url": "https://logicmojo.com/best-data-science-courses" },
          { "text": "What is Data Science?", "url": "https://logicmojo.com/what-is-data-science" },
          { "text": "What is AI", "url": "https://logicmojo.com/what-is-ai" },
          { "text": "What is Data Analytics?", "url": "https://logicmojo.com/what-is-data-analytics" },
          { "text": "Data Scientist Salary", "url": "https://logicmojo.com/data-scientist-salary" },
          { "text": "Data Science Interview Questions", "url": "https://logicmojo.com/data-science-interview-questions" },
          { "text": "Machine Learning Interview Questions", "url": "https://logicmojo.com/machine-learning-interview-questions" },
          { "text": "Data Analyst Salary", "url": "https://logicmojo.com/data-analyst-salary" },
          { "text": "Tableau Interview Questions", "url": "https://logicmojo.com/tableau-interview-questions" },
          { "text": "What is Deep Learning?", "url": "https://logicmojo.com/what-is-deep-learning" },
          { "text": "Hypothesis Testing", "url": "https://logicmojo.com/hypothesis-testing" },
          { "text": "Regression Testing", "url": "https://logicmojo.com/regression-testing" },
          { "text": "Correlation Coefficient", "url": "https://logicmojo.com/correlation-coefficient" },
          { "text": "Logistic Regression Machine Learning", "url": "https://logicmojo.com/logistic-regression-machine-learning" },
          { "text": "Power BI Interview Questions", "url": "https://logicmojo.com/power-bi-interview-questions" },
          { "text": "Artificial Neural Network", "url": "https://logicmojo.com/artifical-neural-network" },
          { "text": "Best AI Courses", "url": "https://logicmojo.com/best-ai-courses" },
          { "text": "Data Science Projects 2026", "url": "data-science-projects" },
          { "text": "AI Examples", "url": "https://logicmojo.com/example-of-AI" },
          { "text": "Convolutional Neural Network", "url": "https://logicmojo.com/convolutional-neural-network" },
          { "text": "AI Course", "url": "https://logicmojo.com/artificial-intelligence-course" },
          { "text": "Artificial intelligence and Machine learning", "url": "https://logicmojo.com/artificial-intelligence-and-machine-learning" },
          { "text": "data analytics courses", "url": "https://logicmojo.com/data-analytics-courses" },
          { "text": "big data analytics", "url": "https://logicmojo.com/big-data-analytics" },
          { "text": "Data Science Course Fees", "url": "https://logicmojo.com/data-science-course-fees" },
          { "text": "Data Science and Artificial Intelligence", "url": "https://logicmojo.com/data-science-and-artificial-intelligence" },
          { "text": "Learn AI From Scratch", "url": "https://logicmojo.com/learn-AI-from-scratch" } ,
          { "text": "Best GenAI Courses", "url": "https://logicmojo.com/best-generative-ai-courses/" },
          { "text": "Generative AI Course", "url": "https://logicmojo.com/generative-ai-course" },
          { "text": "Best AI courses For Working Professionals", "url": "https://logicmojo.com/best-ai-courses-for-working-professionals" },
          { "text": "AI Engineer Salary", "url": "https://logicmojo.com/ai-engineer-salary-2026" },
          { "text": "Best AI ML Courses", "url": "https://logicmojo.com/best-ai-ml-courses" },
          { "text": "AI Projects", "url": "https://logicmojo.com/ai-projects" },
          { "text": "Best data science courses in bangalore", "url": "https://logicmojo.com/best-data-science-courses-in-bangalore" },
          { "text": "Top AI Courses", "url": "https://logicmojo.com/top-ai-courses" }
      ] 
  },
  { 
      title: "Data Structures & Algorithms", 
      icon: "Code",
      links: [
          { "text": "DSA Course", "url": "https://logicmojo.com/data-structures-and-algorithms" },
          { "text": "Data Science Roadmap", "url": "https://logicmojo.com/data-science-roadmap" },
          { "text": "Best AI Courses For Beginners", "url": "https://logicmojo.com/best-ai-courses-for-beginners" },
          { "text": "Data Structures Interview Questions", "url": "https://logicmojo.com/data-structures-interview-questions" },
          { "text": "Best DSA Course", "url": "https://logicmojo.com/best-dsa-course" }, 
          { "text": "Best AI Courses in Bangalore", "url": "https://logicmojo.com/best-ai-courses-in-bangalore" },
          { "text": "Best System Design Courses", "url": "https://logicmojo.com/best-system-design-courses" },
          { "text": "Sorting Algorithms", "url": "https://logicmojo.com/sorting-algorithms" },
          { "text": "Array data structure", "url": "https://logicmojo.com/array-data-structure" },
          { "text": "LinkedList in Data Structure", "url": "https://logicmojo.com/linked-list-data-structure" },
          { "text": "Python Data Structures", "url": "https://logicmojo.com/python-data-structures-problems" },
          { "text": "Sliding Window Algorithm", "url": "https://logicmojo.com/sliding-window-algorithm" },
          { "text": "Quick Sort Algorithm", "url": "https://logicmojo.com/quick-sort-algorithm" },
          { "text": "Data Structures in C", "url": "https://logicmojo.com/data-structures-in-c-problems" },
          { "text": "Tree Data Structures", "url": "https://logicmojo.com/tree-data-structure" },
          { "text": "Data Structures in Java", "url": "https://logicmojo.com/data-structures-in-java" },
          { "text": "Reverse a String", "url": "https://logicmojo.com/reverse-a-string-in-java" },
          { "text": "Hashing in Data Structures", "url": "https://logicmojo.com/hashing-in-data-structure" },
          { "text": "Queue Data Structures", "url": "https://logicmojo.com/data-structures-queue" },
          { "text": "Binary Tree data structure", "url": "https://logicmojo.com/binary-tree-data-structure" },
          { "text": "Insertion Sort", "url": "https://logicmojo.com/insertion-sort" },
          { "text": "Stack in Data Structures", "url": "https://logicmojo.com/stack-in-data-structure" },
          { "text": "Graph Data Structures", "url": "https://logicmojo.com/graph-data-structure" },
          { "text": "What is an Array", "url": "https://logicmojo.com/what-is-an-array" },
          { "text": "DSA Blog", "url": "https://logicmojo.com/dsa-course" },
          { "text": "Full Stack Developer Course", "url": "https://logicmojo.com/full-stack-developer-course" }
      ] 
  },
  { 
      title: "Interview Questions", 
      icon: "Users",
      links: [
          { "text": "Amazon Interview Questions", "url": "https://logicmojo.com/amazon-interview-questions" },
          { "text": "TCS Interview Questions", "url": "https://logicmojo.com/tcs-interview-questions" },
          { "text": "Best Paying Jobs In Technology", "url": "https://logicmojo.com/best-paying-jobs-in-technology" },
          { "text": "Microsoft Interview Questions", "url": "https://logicmojo.com/microsoft-interview-questions" },
          { "text": "Accenture Interview Questions", "url": "https://logicmojo.com/accenture-interview-questions" },
          { "text": "Software Engineer Salary", "url": "https://logicmojo.com/software-engineer-salary" },
          { "text": "Salesforce Interview Questions", "url": "https://logicmojo.com/salesforce-interview-questions" },
          { "text": "Puzzles in Interviews", "url": "https://logicmojo.com/puzzles-questions" },
          { "text": "Highest Paying Jobs in India", "url": "https://logicmojo.com/highest-paying-jobs-in-india" },
          { "text": "In Hand Salary Calculator", "url": "https://logicmojo.com/in-hand-salary-calculator" },
          { "text": "How to Introduce Yourself in an Interview", "url": "https://logicmojo.com/how-to-introduce-yourself-in-an-interview" },
          { "text": "Full Stack Developer", "url": "https://logicmojo.com/full-stack-developer" },
          { "text": "Net Interview Questions", "url": "https://logicmojo.com/dot-net-interview-questions" },
          { "text": "Amazon Leadership Principles", "url": "https://logicmojo.com/amazon-leadership-principles" },
          { "text": "digital signature", "url": "https://logicmojo.com/digital-signature" }
      ] 
  },
  { 
      title: "Java", 
      icon: "Code",
      links: [
          { "text": "Java Interview Questions", "url": "https://logicmojo.com/java-interview-questions" },
          { "text": "Access Modifiers In Java", "url": "https://logicmojo.com/access-modifiers-in-java" },
          { "text": "Collections in Java", "url": "https://logicmojo.com/collections-in-java" },
          { "text": "Constructor In Java", "url": "https://logicmojo.com/constructor-in-java" },
          { "text": "Inheritance In Java", "url": "https://logicmojo.com/inheritance-in-java" },
          { "text": "Method Overriding in Java", "url": "https://logicmojo.com/method-overriding-in-java" },
          { "text": "Interface In Java", "url": "https://logicmojo.com/interface-in-java" },
          { "text": "Method Overloading In Java", "url": "https://logicmojo.com/method-overloading-in-java" },
          { "text": "Data Types in Java", "url": "https://logicmojo.com/data-types-in-java" },
          { "text": "Java8 Features", "url": "https://logicmojo.com/java8-feature-questions" },
          { "text": "Wrapper Class in Java", "url": "https://logicmojo.com/wrapper-class-in-java" },
          { "text": "Fibonacci Series in Java", "url": "https://logicmojo.com/fibonacci-series-in-Java" },
          { "text": "Exception Handling in java", "url": "https://logicmojo.com/exception-handling-in-java-problems" },
          { "text": "Abstract Class in Java", "url": "https://logicmojo.com/abstract-class-in-java" },
          { "text": "Packages In Java", "url": "https://logicmojo.com/packages-in-java" },
          { "text": "Features Of Java", "url": "https://www.logicmojo.com/features-of-java" },
          { "text": "Polymorphism In Java", "url": "https://logicmojo.com/polymorphism-in-java" },
          { "text": "Garbage Collection In Java", "url": "https://logicmojo.com/garbage-collection-in-java" },
          { "text": "Multithreading in Java", "url": "https://logicmojo.com/multithreading-in-java" },
          { "text": "Java Collection", "url": "https://logicmojo.com/collections-problems-in-java" },
          { "text": "Spring Initializr", "url": "https://logicmojo.com/spring-Initializr" },
          { "text": "threads in java", "url": "https://logicmojo.com/threads-in-java" }
      ] 
  },
  { 
      title: "C Language", 
      icon: "Code",
      links: [
          { "text": "C Interview Questions", "url": "https://logicmojo.com/c-interview-question" },
          { "text": "Fibonacci Series in C", "url": "https://logicmojo.com/fibonacci-series-in-C" },
          { "text": "Function in C", "url": "https://logicmojo.com/function-in-c" },
          { "text": "Pointer in C", "url": "https://logicmojo.com/pointer-in-C" },
          { "text": "Data Types in C", "url": "https://logicmojo.com/datatypes-in-c" },
          { "text": "Operators in C", "url": "https://logicmojo.com/operators-in-c" },
          { "text": "Structure in C", "url": "https://logicmojo.com/structure-in-c" },
          { "text": "Include stdio.h", "url": "https://logicmojo.com/include-stdio-h" },
          { "text": "Online GDB Compiler", "url": "https://logicmojo.com/online-gdb-compiler" }
      ] 
  },
  { 
      title: "C++ Language", 
      icon: "Code",
      links: [
          { "text": "C++ Interview Questions", "url": "https://logicmojo.com/cpp-interview-question" },
          { "text": "C++ STL Library", "url": "https://logicmojo.com/cpp-stl" },
          { "text": "Friend Function in C++", "url": "https://logicmojo.com/friend-function-in-cpp" },
          { "text": "Inline Function in C++", "url": "https://logicmojo.com/inline-function-cpp" },
          { "text": "Operator Overloading in C++", "url": "https://logicmojo.com/operator-overloading-in-cpp" },
          { "text": "C++ String", "url": "https://logicmojo.com/cpp-string" },
          { "text": "Constructor in C++", "url": "https://logicmojo.com/constructor-in-cpp" },
          { "text": "Function Overloading in C++", "url": "https://logicmojo.com/function-overloading-in-cpp" },
          { "text": "Include iostream", "url": "https://logicmojo.com/include-iostream" }
      ] 
  },
  { 
      title: "Object Oriented Programming", 
      icon: "Settings",
      links: [
          { "text": "Oops concepts in C++", "url": "https://logicmojo.com/oops-concepts-in-cpp" },
          { "text": "OOPS Interview Questions", "url": "https://logicmojo.com/oops-interview-questions" },
          { "text": "Oops concepts in Java", "url": "https://logicmojo.com/oops-concepts-in-java" },
          { "text": "OOPS concepts in Python", "url": "https://logicmojo.com/oops-concepts-in-python" },
          { "text": "Encapsulation in C++", "url": "https://logicmojo.com/encapsulation-in-cpp" },
          { "text": "Abstraction In Java", "url": "https://logicmojo.com/abstraction-in-java" }
      ] 
  },
  { 
      title: "SQL & Database", 
      icon: "Database",
      links: [
          { "text": "SQL Interview Questions", "url": "https://logicmojo.com/sql-interview-questions" },
          { "text": "Mysql Interview Questions", "url": "https://logicmojo.com/mysql-interview-questions" },
          { "text": "Sql Update Query", "url": "https://logicmojo.com/sql-query-update" },
          { "text": "Index in SQL", "url": "https://logicmojo.com/index-in-sql" },
          { "text": "Sql Join", "url": "https://logicmojo.com/joins-in-sql" },
          { "text": "Dbms Interview questions", "url": "https://logicmojo.com/dbms-interview-questions" },
          { "text": "Normalization in DBMS", "url": "https://logicmojo.com/normalization-in-dbms" },
          { "text": "Sql Group By", "url": "https://logicmojo.com/sql-group-by" },
          { "text": "SQL View", "url": "https://logicmojo.com/view-in-sql" }
      ] 
  },
  { 
      title: "Python Programming", 
      icon: "Code",
      links: [
          { "text": "Python Interview Questions", "url": "https://logicmojo.com/python-interview-questions" },
          { "text": "Python Dictionary", "url": "https://logicmojo.com/python-dictionary" },
          { "text": "Python For Loops", "url": "https://logicmojo.com/python-for-loop" },
          { "text": "Python List", "url": "https://logicmojo.com/python-list" },
          { "text": "Python Tuple", "url": "https://logicmojo.com/python-tuple" },
          { "text": "Exception in Python", "url": "https://logicmojo.com/python-exception-handling" },
          { "text": "Lambda Function In Python", "url": "https://logicmojo.com/lambdafunction-in-python" }
      ] 
  },
  { 
      title: "Operating System & Networking", 
      icon: "Settings",
      links: [
          { "text": "Types of operating system", "url": "https://logicmojo.com/types-of-operating-system" },
          { "text": "Compiler Interpreter difference", "url": "https://logicmojo.com/difference-between-compiler-and-interpreter" },
          { "text": "OSI Model", "url": "https://logicmojo.com/osi-model" },
          { "text": "Networking Interview Questions", "url": "https://logicmojo.com/networking-interview-questions" },
          { "text": "Functions of Operating System", "url": "https://logicmojo.com/functions-of-operating-system" },
          { "text": "Linux Interview Questions", "url": "https://logicmojo.com/linux-interview-questions" }
      ] 
  },
  { 
      title: "System Design", 
      icon: "Settings",
      links: [
          { "text": "System Design", "url": "https://logicmojo.com/system-design" },
          { "text": "System Design Course", "url": "https://logicmojo.com/system-design" },
          { "text": "System Design Blog", "url": "https://logicmojo.com/system-design" },
          { "text": "Microservices Interview Questions", "url": "https://logicmojo.com/microservices-interview-questions" },
          { "text": "Design Patterns in Java", "url": "https://logicmojo.com/design-patterns-in-java" },
          { "text": "Kafka Tutorial", "url": "https://logicmojo.com/kafka-tutorial" },
          { "text": "AWS Interview Questions", "url": "https://logicmojo.com/aws-interview-questions" },
          { "text": "Spring Boot Interview Questions", "url": "https://logicmojo.com/spring-boot-interview-questions" },
          { "text": "Angular Interview Questions", "url": "https://logicmojo.com/angular-interview-questions" },
          { "text": "Angular vs React", "url": "https://logicmojo.com/angular-vs-react" }
      ] 
  },
  { 
      title: "Cloud & DevOps", 
      icon: "Cloud",
      links: [
          { "text": "Jenkins Interview Questions", "url": "https://logicmojo.com/jenkins-interview-questions" },
          { "text": "Kubernetes Interview Questions", "url": "https://logicmojo.com/kubernetes-interview-questions" },
          { "text": "DevOps Interview Questions", "url": "https://logicmojo.com/devops-interview-questions" },
          { "text": "Selenium Interview Questions", "url": "https://logicmojo.com/selenium-interview-questions" },
          { "text": "Manual Testing Interview Questions", "url": "https://logicmojo.com/manual-testing-interview-questions" }
      ] 
  },
  { 
      title: "Others", 
      icon: "BookOpen",
      links: [
          {"text":"Selenium interview questions", "url": "https://logicmojo.com/selenium-interview-questions" },
          {"text":"manual testing interview questions", "url": "https://logicmojo.com/manual-testing-interview-questions" }
      ] 
  }
];

export default function LearningLibrary() {
    const [searchTerm, setSearchTerm] = useState("");
    const [expandedCategories, setExpandedCategories] = useState({});
    const [viewMode, setViewMode] = useState("list");

    const toggleCategory = (categoryIndex) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryIndex]: !prev[categoryIndex]
        }));
    };
    
    const filteredCategories = categories.map(category => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        if (category.title.toLowerCase().includes(lowerSearchTerm)) {
            return category;
        }
        const filteredLinks = category.links.filter(link => 
            link.text.toLowerCase().includes(lowerSearchTerm)
        );
        if (filteredLinks.length > 0) {
            return { ...category, links: filteredLinks };
        }
        return null;
    }).filter(Boolean);

    return (
        <div className="ll-container">
            <div className="ll-header">
                <div className="ll-header-content">
                    <div className="ll-header-text">
                        <h1 className="ll-title">Logicmojo Learning Library</h1>
                        <p className="ll-subtitle">
                            Explore comprehensive programming tutorials, interview questions, and technical resources to advance your career.
                        </p>
                    </div>
                    
                    <div className="ll-search-container">
                        <div className="ll-search-wrapper">
                            <Search className="ll-search-icon" />
                            <input
                                type="text"
                                placeholder="Search for a topic, e.g., 'System Design'..."
                                className="ll-search-input"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="ll-view-toggle-container">
                        <div className="ll-view-toggle">
                            <button
                                onClick={() => setViewMode("grid")}
                                className={`ll-view-btn ${viewMode === "grid" ? "active" : ""}`}
                            >
                                Grid View
                            </button>
                            <button
                                onClick={() => setViewMode("list")}
                                className={`ll-view-btn ${viewMode === "list" ? "active" : ""}`}
                            >
                                List View
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ll-content-area">
                {viewMode === "grid" ? (
                    <div className="ll-grid-view">
                        {filteredCategories.map((category, idx) => {
                            const IconComponent = iconMap[category.icon] || BookOpen;
                            const isExpanded = !!expandedCategories[idx];
                            const displayLinks = isExpanded ? category.links : category.links.slice(0, 5);
                            
                            return (
                                <div key={idx} className="ll-card">
                                    <div className="ll-card-header">
                                        <IconComponent className="ll-card-icon" />
                                        <h2 className="ll-card-title">{category.title}</h2>
                                        <p className="ll-card-subtitle">{category.links.length} resources</p>
                                    </div>
                                    <div className="ll-card-body">
                                        <div className="ll-card-links">
                                            {displayLinks.map((link) => (
                                                <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer" className="ll-card-link">
                                                    <span className="ll-link-text">{link.text}</span>
                                                    <ExternalLink className="ll-link-icon" />
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                    {category.links.length > 5 && (
                                        <div className="ll-card-footer">
                                            <button onClick={() => toggleCategory(idx)} className="ll-show-more-btn">
                                                {isExpanded ? "Show Less" : `Show ${category.links.length - 5} More`}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="ll-list-view">
                        {filteredCategories.map((category, idx) => {
                            const IconComponent = iconMap[category.icon] || BookOpen;
                            const isExpanded = !!expandedCategories[idx];
                            
                            return (
                                <div key={idx} className="ll-accordion">
                                    <button onClick={() => toggleCategory(idx)} className="ll-accordion-btn">
                                        <div className="ll-accordion-title-group">
                                            <IconComponent className="ll-card-icon" />
                                            <div className="ll-accordion-text-group">
                                                <h2 className="ll-card-title">{category.title}</h2>
                                                <p className="ll-card-subtitle">{category.links.length} resources</p>
                                            </div>
                                        </div>
                                        {isExpanded ? <ChevronDown className="ll-chevron-icon" /> : <ChevronRight className="ll-chevron-icon" />}
                                    </button>
                                    {isExpanded && (
                                        <div className="ll-accordion-content">
                                            <div className="ll-accordion-links-grid">
                                                {category.links.map((link) => (
                                                    <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer" className="ll-accordion-link">
                                                        <span className="ll-link-text">{link.text}</span>
                                                        <ExternalLink className="ll-link-icon" />
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {filteredCategories.length === 0 && (
                    <div className="ll-no-results">
                        <BookOpen className="ll-no-results-icon" />
                        <h3>No Results Found</h3>
                        <p>Try adjusting your search to find what you're looking for.</p>
                    </div>
                )}
            </div>
        </div>
    );
}